export const CRYPTO = {

    encoder: new TextEncoder(),
    decoder: new TextDecoder(),

    // 🔐 Майстер-пароль (використовується лише всередині deriveKey)
    MASTER_SECRET: 'BbmRvdBecWmJDL6SXfzwSPgy2aeCff22',

    // 🔧 Перетворення рядка (ASCII) на Uint8Array
    strToBytes: (str) => Uint8Array.from(str.split('').map((c) => c.charCodeAt(0))),

    toBase64: (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))),

    fromBase64: (b64) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0)),

    // 🔑 Генерація ключа з MASTER_SECRET та переданого salt
    deriveKey: async function(saltStr) {
        const saltBytes = this.strToBytes(saltStr);

        const keyMaterial = await crypto.subtle.importKey(
            'raw',
            this.encoder.encode(this.MASTER_SECRET),
            'PBKDF2',
            false,
            ['deriveKey']
        );

        return crypto.subtle.deriveKey(
            {
                name: 'PBKDF2',
                salt: saltBytes,
                iterations: 100_000,
                hash: 'SHA-256',
            },
            keyMaterial,
            {
                name: 'AES-GCM',
                length: 256,
            },
            false,
            ['encrypt', 'decrypt']
        );
    },

    // ✨ Шифрування
    encrypt: async function(plainText, ivStr, saltStr) {
        const iv = this.strToBytes(ivStr);
        const key = await this.deriveKey(saltStr);

        const encryptedBuffer = await crypto.subtle.encrypt(
            {
                name: 'AES-GCM',
                iv: iv,
            },
            key,
            this.encoder.encode(plainText)
        );

        return this.toBase64(encryptedBuffer);
    },

    // ✨ Розшифрування
    decrypt: async function(cipherText, ivStr, saltStr) {
        const iv = this.strToBytes(ivStr);
        const key = await this.deriveKey(saltStr);
        const encryptedBytes = this.fromBase64(cipherText);

        const decryptedBuffer = await crypto.subtle.decrypt(
            {
                name: 'AES-GCM',
                iv: iv,
            },
            key,
            encryptedBytes
        );

        return this.decoder.decode(decryptedBuffer);
    }
}